import { useEffect, useRef } from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { birthdayNotificationService } from '@/services/birthdayNotificationService';

export const useBirthdayNotifications = () => {
  const { user, profile } = useAuth();
  const initializedRef = useRef(false);

  useEffect(() => {
    // Só inicializa uma vez por sessão
    if (user && profile && profile.status === 'ACTIVE' && !initializedRef.current) {
      console.log('🎂 Inicializando serviço de notificações de aniversário...');
      initializedRef.current = true;
      
      // Solicita permissão para notificações se necessário
      if ('Notification' in window && Notification.permission === 'default') {
        Notification.requestPermission().then(permission => {
          if (permission === 'granted') {
            console.log('🎂 Permissão para notificações concedida');
            birthdayNotificationService.startBirthdayMonitoring();
          } else {
            console.log('🎂 Permissão para notificações negada');
          }
        });
      } else if (Notification.permission === 'granted') {
        // Se já tem permissão, inicia o monitoramento
        birthdayNotificationService.startBirthdayMonitoring();
      }
    }

    // Cleanup apenas quando o usuário realmente sair
    return () => {
      if (!user && initializedRef.current) {
        console.log('🎂 Parando serviço de notificações de aniversário...');
        birthdayNotificationService.stopBirthdayMonitoring();
        initializedRef.current = false;
      }
    };
  }, [user, profile]);

  return {
    startMonitoring: () => birthdayNotificationService.startBirthdayMonitoring(),
    stopMonitoring: () => birthdayNotificationService.stopBirthdayMonitoring(),
    checkBirthdays: () => birthdayNotificationService.checkBirthdaysManually(),
    getStats: () => birthdayNotificationService.getBirthdayStats()
  };
};
